import React, { useEffect, useState, useCallback } from 'react';
import superagent from 'superagent';
import CircularProgress from '@mui/material/CircularProgress';

import styles from './index.module.sass';

import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Pedidos from './Pedidos.js';
import Ordenando from './Ordenando.js';
import QNCS from './QNCS.js';
import Kois from './Kois.js';
import NoStockProducts from './NoStockProducts';

const location = process.env.REACT_APP_COUNTRY;

const Indicators = (props) => {
  const { setSectionName, device, setOptionSelected, webserviceURL, token } = props;

  const [value, setValue] = useState(0);
  const [indicatorArray, setIndicatorArray] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowSelected, setRowSelected] = useState(null);
  const [inventory, setInventory] = useState([]);

  const requestIndicator = useCallback(
    (option) => {
      setLoading(true);
      const url = `${webserviceURL}/getAdminIndicadores?opcion=${option}`;
      superagent
        .get(url)
        .set('token', token)
        .auth(token, { type: 'bearer' })
        .then((res) => {
          const data = res.body;
          if (data) setIndicatorArray(data);
          setRowSelected(null);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err, 'ERROR EN INDICADORES');
          setLoading(false);
        });
    },
    [webserviceURL, token],
  );

  function getInventario() {
    setLoading(true);
    const url = `${webserviceURL}/GetInventario?idioma=1`;
    superagent
      .get(url)
      .set('token', token)
      .auth(token, { type: 'bearer' })
      .then((res) => {
        const data = res?.body || {};
        const { listaInventario = [] } = data;
        setInventory(listaInventario);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err, 'ERROR EN INVENTARIO INDICADORES');
        setLoading(false);
      });
  }

  useEffect(() => {
    setSectionName('Indicadores');
    setOptionSelected('indicators');
    requestIndicator(1);
  }, [requestIndicator, setOptionSelected, setSectionName]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue <= 3) requestIndicator(newValue + 1);
    if (newValue === 4) getInventario();
  };

  return (
    <div id={styles.Indicators}>
      <AppBar position='static' color='default'>
        <Tabs
          value={value}
          onChange={handleChange}
          className={styles.tabs}
          indicatorColor='primary'
          textColor='primary'
          variant={device.screenSize === 'phone' ? 'scrollable' : 'fullWidth'}
          scrollButtons
          allowScrollButtonsMobile>
          <Tab label='PEDIDOS' />
          <Tab label='ORDENANDO' />
          <Tab label='QNCS' />
          <Tab label='KOIS' />
          {location === 'US' && <Tab label='PRODUCTOS' />}
        </Tabs>
      </AppBar>
      {(loading && (
        <div className={styles.loadingContainer}>
          <CircularProgress className={styles.circularProgress} />
        </div>
      )) || (
        <div className={styles.tableContainer}>
          {value === 0 && (
            <Pedidos
              device={device}
              indicatorArray={indicatorArray}
              rowSelected={rowSelected}
              setRowSelected={setRowSelected}
            />
          )}
          {value === 1 && (
            <Ordenando
              device={device}
              indicatorArray={indicatorArray}
              rowSelected={rowSelected}
              setRowSelected={setRowSelected}
            />
          )}
          {value === 2 && (
            <QNCS
              device={device}
              indicatorArray={indicatorArray}
              rowSelected={rowSelected}
              setRowSelected={setRowSelected}
            />
          )}
          {value === 3 && (
            <Kois
              device={device}
              indicatorArray={indicatorArray}
              rowSelected={rowSelected}
              setRowSelected={setRowSelected}
            />
          )}
          {value === 4 && (
            <NoStockProducts
              device={device}
              inventory={inventory}
              rowSelected={rowSelected}
              setRowSelected={setRowSelected}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Indicators;
